var _defs, _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".lock-6_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "lock-6_svg__a",
    x: 3.75,
    y: 9.75,
    width: 16.5,
    height: 13.5,
    rx: 1.5,
    ry: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "lock-6_svg__a",
    d: "M6.75 9.75V6a5.25 5.25 0 0110.5 0v3.75"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "lock-6_svg__a",
    cx: 12,
    cy: 16.5,
    r: 2.25
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6bm9uZTtzdHJva2U6Y3VycmVudENvbG9yO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6MS41cHg7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5sb2NrLTY8L3RpdGxlPjxyZWN0IGNsYXNzPSJhIiB4PSIzLjc1IiB5PSI5Ljc1IiB3aWR0aD0iMTYuNSIgaGVpZ2h0PSIxMy41IiByeD0iMS41IiByeT0iMS41Ii8+PHBhdGggY2xhc3M9ImEiIGQ9Ik02Ljc1LDkuNzVWNmE1LjI1LDUuMjUsMCwwLDEsMTAuNSwwVjkuNzUiLz48Y2lyY2xlIGNsYXNzPSJhIiBjeD0iMTIiIGN5PSIxNi41IiByPSIyLjI1Ii8+PC9zdmc+";
export { SvgLock6 as ReactComponent };